// eslint-disable-next-line vue/multi-word-component-names
<template>
  <div>Ini About Simakad</div>
</template>
